import React, { useEffect, useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { allData } from "./constants";
import storage from "@/utils/storage";
import axios from "axios";
import "./transaction.css";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import MervIcon from "@/assets/mervIcon.svg";
import { useWalletAmount } from "@/components/Elements/api/getWalletamount";
import { useInvestedCoins } from "../api/getInvestedCoins";
import yellowt from "@/assets/yellow-t.png";
import CurrencyFormat from "react-currency-format";
const tableHead = {
  transactionId: "Transaction Id",
  LotteryName: "Lottery Name",
  Jackpot: "Jackpot",
  userName: "User Name",
  ticketNumber: "Ticket Number",
  amount: "Amount",
  jackpotPricePayedByUser:"G2F Amount",
  freeTicketSpinAmountWin: "Free Ticket Amount",
  lotteryWinningPrize: "Lottery Win Prize",
  commissionAmount: "Commission Amount",
  payoutAmount: "Payout Amount",
  payoutRequest: "Payout Request",
  transactionStatus: "Transaction Status",
  createdDate: "Created Date",
  transactionType: "Transaction Type",
};

const MyTransactionList = () => {
  const countPerPage = 10;
  const dataWallet = useWalletAmount({});
  console.log(dataWallet, "dataWallet");
  console.log(dataWallet?.data?.walletAmount, "dataWallet Amount");
  const coins = useInvestedCoins({});
  const [value, setValue] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(10);
  const [data, setData] = useState([
    {
      LotteryName: "",
      amount: 0,
      Jackpot: true,
      commissionAmount: "",
      createdDate: "",
      lotteryWinningPrize: "0",
      payoutAmount: "",
      transactionId: "",
      transactionStatus: "",
      userName: "",
      ticketNumber: "",
    },
  ]);
  console.log(data, "data");
  const [loading, setLoading] = React.useState(false);
  console.log(loading, "loading Loading");
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("dec");
  console.log(sortField, sortOrder, "sortOreder")
  const [collection, setCollection] = React.useState(
    cloneDeep(allData.slice(0, countPerPage))
  );
  const searchData = React.useRef(
    throttle((val) => {
      const query = val.toLowerCase();
      setCurrentPage(1);
      const data = cloneDeep(
        allData
          .filter((item) => item.name.toLowerCase().indexOf(query) > -1)
          .slice(0, countPerPage)
      );
      setCollection(data);
    }, 400)
  );

  React.useEffect(() => {
    if (!value) {
      updatePage(1);
    } else {
      searchData.current(value);
    }
  }, [value]);

  useEffect(() => {
    getData(value, 1);
  }, [value, sortField,
    sortOrder,]);

  const getData = async (value, p) => {
    let token = storage.getToken();
    setLoading(true);
    let pageLimit;
    pageLimit = value != "" ? totalRecords : 10;
    const payload = {
      page: p,
      limit: pageLimit,
      sortField,
      sortOrder,
    };
    await axios
      .post(
        `${process.env.API_URL_PREFIX}/api/v1/user/myTransactionList?search=${value}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setData(res.data.data);
        setTotalRecords(res.data.transactionPageCount);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setCollection(cloneDeep(allData.slice(from, to)));
    getData(value, p);
  };
  console.log("?search=", value);

  const Item = styled(Paper)(({ theme }) => ({
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  }));
  var cardStyle = {
    display: "block",
    transitionDuration: "0.3s",
    height: "auto",
    background: "#050518",
    boxShadow: "0 0 10px #8264eeb3",
    borderRadius: "20px",
  };

  const excludedColumns = [
    "transactionId",
    "LotteryName",
    "Jackpot",
    "userName",
    "ticketNumber",
    "freeTicketAmt",
    "lotteryWinningPrize",
    "commissionAmount",
    "payoutAmount",
    "payoutRequest",
    "transactionStatus",
    "createdDate",
  ];

  const tableRows = (rowData: { key: Record<string, any>; index: number }) => {
    const { key, index } = rowData;
    const tableCell = Object.keys(tableHead);

    const columnData = tableCell.map((keyD, i) => {
      let cellStyle: React.CSSProperties = {};

      const value = key[keyD];
      let displayValue = value;

      if (keyD === "amount") {
        displayValue =
          key["transactionType"] === "OUT" ? `-${value}` : `+${value}`;
      }

      if (keyD === "lotteryWinningPrize" && value > 0) {
        cellStyle.color = "green";
        cellStyle.fontWeight = "bold";
      }
      if (keyD === "Jackpot") {
        cellStyle.color = key["jackpotPricePayedByUser"] > 0 ? "green" : "red";
        displayValue = key["jackpotPricePayedByUser"] > 0 ? "Yes" : "No";
      }
      if (keyD === "freeTicketSpinAmountWin") {
        cellStyle.color = "green";
      } else if (!excludedColumns.includes(keyD)) {
        cellStyle.color = key["transactionType"] === "OUT" ? "red" : "green";
        cellStyle.fontWeight = "bold";
      }

      return (
        <td key={i} className="td" style={cellStyle}>
          {displayValue}
        </td>
      );
    });

    return (
      <tr className="table-th2" key={index} style={{ textAlign: "center" }}>
        {columnData}
      </tr>
    );
  };

  const tableData = () => {
    return data.map((key, index) => tableRows({ key, index }));
  };

  const headRow = () => {
    return Object.values(tableHead).map((title, index) => (
      <th key={index}>
        <div className="m-auto minw-maxcontent" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {title}
          {title === "Lottery Win Prize" && (
            <button
              onClick={() => handleSort("lotteryWinningPrize")}
              style={{ border: "none", background: "white", cursor: "pointer", fontSize: "14px" }}
            >
              {sortOrder === "desc" ? "↑" : "↓"}
            </button>
          )}
        </div>
      </th>
    ));
  };
  console.log("totalRecords", totalRecords);
  const handleSort = (field) => {
    console.log("Sorting clicked:", field, sortField, sortOrder);
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };



  return (
    <>
      <Box
        sx={{
          display: { md: "flex", xs: "none" },
        }}
      >
        <input
          placeholder="Search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="search"
        />
      </Box>
      <Box sx={{ height: "auto", marginTop: "10px" }}>
        <Card style={cardStyle}>
          <CardContent sx={{ padding: { xs: "10px", md: "20px" } }}>
            <Grid container justifyContent={"space-between"}>
              <Grid
                item
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: "10px",
                }}
              >
                {" "}
                <Typography
                  component="h4"
                  sx={{
                    fontSize: {
                      xs: "14px !important",
                      md: "16px !important",
                      lg: "20px !important",
                    },
                  }}
                >
                  My Transactions
                </Typography>
                <Box
                  sx={{
                    display: { md: "none", xs: "flex" },
                  }}
                >
                  <input
                    placeholder="Search"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="search"
                    style={{
                      width: "auto",
                      maxWidth: "200px",
                      margin: "0px",
                      padding: "5px 10px",
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                sx={{
                  display: "flex",
                  flexFlow: "column",
                  gap: "5px",
                  color: "#fff",
                  fontSize: {
                    xs: "14px !important",
                    md: "16px !important",
                    lg: "20px !important",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img
                    src={MervIcon}
                    className="log-merv-wallet"
                    style={{
                      height: "auto",
                      width: "22px",
                    }}
                    alt="Merv"
                  />
                  {coins?.data?.data}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img
                    src={yellowt}
                    className="log-merv-wallet"
                    style={{
                      height: "auto",
                      width: "22px",
                    }}
                    alt="wallet"
                  />
                  <CurrencyFormat
                    value={dataWallet?.data?.walletAmount}
                    thousandSeparator={"."}
                    displayType={"text"}
                    decimalSeparator={","}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className="table-t1 sticky-table">
                  <table
                    style={{
                      borderCollapse: "collapse",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    {data.length > 0 && !loading && (
                      <thead>
                        <tr className="table-th">{headRow()}</tr>
                      </thead>
                    )}
                    <tbody>
                      {loading ? (
                        <tr>
                          <td
                            colSpan={14}
                            style={{ height: "auto", textAlign: "center" }}
                          >
                            <CircularProgress size={80} />
                          </td>
                        </tr>
                      ) : data.length === 0 ? (
                        <tr>
                          <td colSpan={14}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="400px"
                              textAlign="center"
                            >
                              <Typography
                                variant="h6"
                                fontWeight="bold"
                                style={{ color: "#ff862d" }}
                              >
                                📜 No transactions yet <br />
                                ✨ Your first win could make history! 🏆
                              </Typography>
                            </Box>
                          </td>
                        </tr>
                      ) : (
                        <>{tableData()}</>
                      )}
                    </tbody>

                  </table>
                </Box>
              </Grid>
              {value == "" ? (
                <Box className="paginationBox">
                  <Pagination
                    pageSize={countPerPage}
                    onChange={updatePage}
                    current={currentPage}
                    total={totalRecords}
                  />
                </Box>
              ) : (
                ""
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};
export default MyTransactionList;
